export default "__VITE_ASSET__Bw3VOpz4__"